/**
 * Single source of truth for “product app” URL space vs corporate/marketing pages.
 * Any Mux/player embed that must never appear on www marketing routes must either:
 * - live under a path matched by {@link isProductAppPath}, and/or
 * - use `ProductMuxIframe` (`components/common/ProductMuxIframe.jsx`) which enforces the same check.
 *
 * When you add a new protected app route in App.jsx where dashboard videos should appear,
 * extend this matcher (keep in sync with Routes).
 */

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isProductAppPath(pathname) {
  if (!pathname || typeof pathname !== 'string') return false
  if (pathname === '/scorecard') return true
  const exactRoots = ['/dashboard', '/calendar', '/analytics', '/company-analysis', '/settings']
  for (const root of exactRoots) {
    if (pathname === root || pathname.startsWith(`${root}/`)) return true
  }
  if (pathname === '/agenda' || pathname.startsWith('/agenda/')) return true
  if (pathname.startsWith('/meeting/')) return true
  return false
}
